export const POSTAL_CODE_REGEX = {
    US: /^\d{5}(-\d{4})?$/,
    CA: /^[A-Z]\d[A-Z] \d[A-Z]\d$/i
}

/**
 * Returns the postal code regex for the given country code, or null if no
 * client-side pattern is defined for that country.
 * @param {string} countryCode
 * @returns {RegExp|null}
 */
export const getPostalCodeRegex = (countryCode) => {
    return POSTAL_CODE_REGEX[countryCode?.toUpperCase()] ?? null
}

/**
 * Formats a raw postal code string for the given country.
 * Returns the formatted value, or the original value if no formatting applies.
 * @param {string} value
 * @param {string} countryCode
 * @returns {string}
 */
export const formatPostalCodeInput = (value, countryCode) => {
    const code = countryCode?.toUpperCase()

    if (code === 'CA') {
        const raw = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6)
        return raw.length > 3 ? raw.slice(0, 3) + ' ' + raw.slice(3) : raw
    }

    if (code === 'US') {
        let formatted = value.replace(/\s/g, '').replace(/[^0-9-]/g, '')
        const parts = formatted.split('-')
        if (parts.length > 2) {
            formatted = parts[0] + '-' + parts[1]
        }
        if (!formatted.includes('-') && formatted.length > 5) {
            formatted = formatted.slice(0, 5) + '-' + formatted.slice(5, 9)
        }
        if (formatted.includes('-')) {
            const [before, after] = formatted.split('-')
            formatted = before.slice(0, 5) + '-' + after.slice(0, 4)
        } else {
            formatted = formatted.slice(0, 5)
        }
        return formatted
    }

    return value
}

/**
 * Returns an inputProps factory for react-hook-form fields, applying
 * country-specific postal code formatting on change.
 * @param {string} countryCode
 * @returns {function}
 */
export const getPostalCodeInputProps = (countryCode) => {
    const code = countryCode?.toUpperCase()
    if (code === 'CA') {
        return ({onChange}) => ({
            maxLength: 7,
            onChange(evt) {
                onChange(formatPostalCodeInput(evt.target.value, 'CA'))
            }
        })
    }
    if (code === 'US') {
        return ({onChange}) => ({
            maxLength: 10,
            onChange(evt) {
                onChange(formatPostalCodeInput(evt.target.value, 'US'))
            }
        })
    }
    return undefined
}
